import { formatTime, zonedMinutes } from 'src/shared/utils/datetime';

interface SlotGridProps {
  /** Free start instants, as the availability endpoint returns them. */
  slots: string[];
  selected: string | null;
  onSelect: (slot: string) => void;
  timeZone?: string;
}

const PARTS = [
  { label: 'Mañana', from: 0, until: 12 * 60 },
  { label: 'Tarde', from: 12 * 60, until: 18 * 60 },
  { label: 'Noche', from: 18 * 60, until: 24 * 60 },
];

/**
 * Free times as chips, grouped into morning, afternoon and evening.
 *
 * Grouped because a day at 15-minute steps is forty buttons: split in three,
 * "something after lunch" is one glance instead of a scan.
 */
export default function SlotGrid({ slots, selected, onSelect, timeZone }: SlotGridProps) {
  const groups = PARTS.map((part) => ({
    label: part.label,
    slots: slots.filter((slot) => {
      const minute = zonedMinutes(slot, timeZone);
      return minute >= part.from && minute < part.until;
    }),
  })).filter((group) => group.slots.length > 0);

  return (
    <div className="v-slots">
      {groups.map((group) => (
        <div key={group.label} className="v-slots__group" role="group" aria-label={group.label}>
          <p className="v-eyebrow mb-2">{group.label}</p>
          <div className="v-slots__grid">
            {group.slots.map((slot) => (
              <button
                key={slot}
                type="button"
                className="v-chip v-chip--time"
                aria-pressed={selected === slot}
                onClick={() => onSelect(slot)}
              >
                {formatTime(slot, timeZone)}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
